import React, { Element } from 'react'
import PropTypes from 'prop-types'

import { Logo, SkipLink } from '../../components'

import headerStyles from '../../containers/Header/Header.scss'

export const MiniHeader = ({ sticky, skipToContentTag, miniHeaderContent, headerRef }) => (
  // @todo: sticky prop - react hook >_> ?

  <header
    id='haas-v2-mini'
    className={`${headerStyles.header}${sticky ? ` ${headerStyles['header--sticky']}` : ''}`}
    ref={headerRef}>
    <div className={headerStyles.main}>
      <div className={headerStyles.container}>
        <Logo />
        <SkipLink skipToContentTag={skipToContentTag} />
        {miniHeaderContent}
      </div>
    </div>
  </header>
)

MiniHeader.propTypes = {
  headerRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  miniHeaderContent: PropTypes.element,
  skipToContentTag: PropTypes.string,
  sticky: PropTypes.bool,
}

MiniHeader.defaultProps = {
  sticky: false,
  skipToContentTag: '',
  miniHeaderContent: null,
}

export default MiniHeader
